import React from 'react';
import MathText from './MathText.jsx';

export default function LearnerWritingEvidence({ result }) {
    const stages = result.writingEvidence?.stages;
    if (!Array.isArray(stages) || !stages.length) return <MathText>{result.learnerAnswer || '[blank]'}</MathText>;
    const names = { planning: 'Planning / mind map', draft: 'First draft', final: 'Final response' };
    return <div className="writing-stage-evidence">
        {['planning', 'draft', 'final'].map(key => {
            const stage = stages.find(entry => entry.stage === key);
            if (!stage) return null;
            const sources = (result.writingEvidence.pageSources || []).filter(page => page.stage === key && !page.duplicateOf);
            const ratings = sources.flatMap(page => page.ratings || []);
            const context = sources.flatMap(page => (page.segments || []).filter(segment => segment.source !== 'handwriting' && segment.source !== 'rating')
                .map(segment => ({ ...segment, page: page.page })));
            return <section key={key} aria-label={names[key]} style={{ marginBottom: '1rem' }}>
                <strong>{names[key]}</strong>
                {!!stage.pages?.length && <span> — PDF page{stage.pages.length > 1 ? 's' : ''} {stage.pages.join(', ')}</span>}
                {stage.status === 'uncertain' && <p role="alert">Source text is unclear or cropped. Review this stage before assigning marks.</p>}
                {stage.status === 'unavailable' && <p>Stage not supplied.</p>}
                {stage.status === 'blank' && <p>No handwritten prose recorded.</p>}
                {!!stage.text && <div style={{ whiteSpace: 'pre-wrap' }}>{stage.text}</div>}
                {ratings.map((rating, index) => <p key={`rating-${index}`}>Rating: <span>{rating.text}</span> (PDF page {rating.page})</p>)}
                {!!context.length && <details><summary>Printed context and edits — excluded from learner word count</summary>
                    {context.map((segment, index) => <p key={index}><strong>{segment.source.replace(/_/g, ' ')} (PDF page {segment.page}): </strong>{segment.text}</p>)}
                </details>}
            </section>;
        })}
    </div>;
}
